
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import cx from '@/utils/classes';
import getBorderClasses from '@/utils/getBorderClasses';
import focusService from '@/utils/FocusService';
import isMobile from '@/utils/isMobile';

@Component
export default class Square extends Vue {
  @Prop({ type: String }) public name!: string;
  @Prop({ type: String }) public value!: string;
  @Prop({ type: Boolean }) public disabled!: boolean;
  @Prop({ type: Boolean }) public warning!: boolean;
  @Prop({ type: Boolean }) public error!: boolean;
  @Prop({ type: Boolean }) public highlight!: boolean;

  get classes() {
    return cx('square', ...getBorderClasses(this.name));
  }

  get inputClasses() {
    const hasWarning = this.warning && !this.error;
    const hasError = this.error;
    const hasHighlight = this.highlight;

    return cx(
      'square__input',
      hasHighlight && `square__input--highlight`,
      hasWarning && `square__input--warning`,
      hasError && `square__input--error`
    );
  }

  get fieldName() {
    return `sq_${this.name}`;
  }

  get fieldType() {
    return isMobile() ? 'number' : 'text';
  }

  public onFocus() {
    focusService.setFocus(this.name);
  }

  public onBlur() {
    focusService.setFocus(undefined);
  }

  @Emit()
  public onUserInput(event: KeyboardEvent) {
    const { value: rawValue } = event.target as HTMLInputElement;

    const num = Number(rawValue);
    const isInvalid = isNaN(num) || num < 1 || num > 9;
    const value = isInvalid ? '' : rawValue;

    this.$forceUpdate(); // required to force the re-render so the ui looks like the backing data
    return { square: this.name, value };
  }

  @Emit()
  public onKeyUp(event: KeyboardEvent) {
    // kick it up
  }
}
